import React from 'react';

export interface SpinnerProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    color?: 'primary' | 'secondary' | 'accent' | 'white';
    className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
    size = 'md',
    color = 'primary',
    className = '',
}) => {
    const sizeClasses = {
        xs: 'w-4 h-4',
        sm: 'w-6 h-6',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
        xl: 'w-16 h-16',
    };

    // Brand tokens so spinners match the theme in both light & dark modes.
    const colorClasses = {
        primary: 'text-primary border-primary/20 border-t-primary',
        secondary: 'text-secondary border-secondary/20 border-t-secondary',
        accent: 'text-accent border-accent/20 border-t-accent',
        white: 'text-white border-white/20 border-t-white',
    };

    return (
        <div className={`inline-flex items-center justify-center ${className}`}>
            <svg
                className={`animate-spin ${sizeClasses[size]} ${colorClasses[color]}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
            </svg>
        </div>
    );
};

export const SpinnerOverlay: React.FC<{ isLoading: boolean; message?: string }> = ({
    isLoading,
    message = 'Loading...',
}) => {
    if (!isLoading) return null;

    return (
        <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-base-100/80 backdrop-blur-sm">
            <Spinner size="xl" color="primary" />
            <p className="mt-4 text-lg font-medium text-base-content">{message}</p>
        </div>
    );
};
